<h1 mat-dialog-title>Impersonate User</h1>

<div mat-dialog-content>
	<form [formGroup]="formGroup">
		<div class="row">
			<div>
				<div class="dx-fieldset" style="margin: unset !important">
					<div class="dx-field" style="width: 100%">
						<div [className]="formGroup.get('email')?.hasError('required') && formGroup.get('email')?.touched ? 'validation-error' : ''" style="width: inherit">
							<dx-select-box
								searchExpr="name"
								searchMode="contains"
								displayExpr="name"
								valueExpr="internalUserGUID"
								formControlName="email"
								[items]="users"
								[(value)]="userGUID"
								[searchEnabled]="true"
								searchMode="contains"
								[showDropDownButton]="false"
								placeholder="Select User"
							>
							</dx-select-box>

							<span class="error-text">User selection required.</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</form>
</div>

<div mat-dialog-actions [align]="'end'">
	<app-goldstar-button [elementId]="elementIdPrefix + 'cancel-btn'" (buttonClicked)="onNoClick()" [textColor]="'#024b81'" color="#fff" [borderColor]="'#024b81'">Cancel</app-goldstar-button>
	<app-goldstar-button [elementId]="elementIdPrefix + 'ok-btn'" (buttonClicked)="save()" [color]="'#024b81'" [borderColor]="'#024b81'">Ok</app-goldstar-button>
</div>
